import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { capitalize } from 'lodash-es';
import { Row, Typography } from 'seagull';
import { serviceCostModel } from '~/models';
import { ServiceCostType } from '~/models/service-cost';
import { utils } from '~/utils';
export const reviewServicesTextsPath = 'clientFlow.reviewServices';
export const renderServicePrice = (service, reviewTexts)=>{
    switch(service.cost.pricingType){
        case ServiceCostType.Fixed:
        case ServiceCostType.Variable:
            var _service_cost_discount;
            return /*#__PURE__*/ _jsxs(Row, {
                gap: 8,
                alignItems: "baseline",
                children: [
                    /*#__PURE__*/ _jsxs(Row, {
                        gap: 2,
                        alignItems: "baseline",
                        children: [
                            /*#__PURE__*/ _jsx(Typography, {
                                variant: "h6",
                                skin: "standard",
                                children: utils.formatDollarAmount(utils.applyDiscount(service.cost.price, service.cost.discount))
                            }),
                            serviceCostModel.isVariablePrice(service.cost) && /*#__PURE__*/ _jsxs(Typography, {
                                variant: "paragraph2",
                                skin: "secondary",
                                children: [
                                    "/ ",
                                    capitalize(serviceCostModel.formattedUnitName(service.cost))
                                ]
                            })
                        ]
                    }),
                    ((_service_cost_discount = service.cost.discount) === null || _service_cost_discount === void 0 ? void 0 : _service_cost_discount.amount()) && /*#__PURE__*/ _jsx(Typography, {
                        skin: "secondary",
                        textDecoration: "line-through",
                        children: utils.formatDollarAmount(service.cost.price)
                    })
                ]
            });
        case ServiceCostType.Range:
            var _service_cost_discount1;
            return /*#__PURE__*/ _jsxs(Row, {
                gap: 4,
                alignItems: "baseline",
                children: [
                    /*#__PURE__*/ _jsxs(Typography, {
                        variant: "h6",
                        skin: "standard",
                        children: [
                            service.cost.minPrice && !service.cost.minPrice.eq(0) ? "".concat(utils.formatDollarAmount(utils.applyDiscount(service.cost.minPrice, service.cost.discount)), " - ") : reviewTexts.upTo(),
                            utils.formatDollarAmount(utils.applyDiscount(service.cost.maxPrice, service.cost.discount))
                        ]
                    }),
                    ((_service_cost_discount1 = service.cost.discount) === null || _service_cost_discount1 === void 0 ? void 0 : _service_cost_discount1.amount()) && /*#__PURE__*/ _jsxs(Typography, {
                        skin: "secondary",
                        textDecoration: "line-through",
                        children: [
                            !!service.cost.minPrice && "".concat(utils.formatDollarAmount(service.cost.minPrice), " - "),
                            utils.formatDollarAmount(service.cost.maxPrice)
                        ]
                    })
                ]
            });
        default:
            return null;
    }
};
